import classNames from 'classnames';
import { FC } from 'react';

import { CloseIcon } from '@gem/icons';
import { ICommonPopupsProps, Popup, useClosePopupOnNavigation } from '@gem/popups';
import { customScrollStyles, IconButton } from '@gem/ui-kit';

import { MyProfile } from 'APP/main/Profile/MyProfile/MyProfile';

import { IMyProfilePopupParams, useMyProfilePopupPresenter } from './MyProfilePopup.presenter';
import styles from './MyProfilePopup.styles.m.css';

export const MyProfilePopup: FC<ICommonPopupsProps<IMyProfilePopupParams>> = (props) => {
  const { popupInstance, params = {} } = props;
  const presenter = useMyProfilePopupPresenter(props);
  useClosePopupOnNavigation(popupInstance);

  return (
    <Popup
      isOpened
      isHidden={popupInstance.isHidden}
      onClose={popupInstance.close}
      handlePrevStep={params.hasBackButton ? presenter.onBack : undefined}
    >
      <div
        className={classNames(styles.scrollContainer, customScrollStyles.container)}
        data-test="my-profile-popup"
      >
        {!params.hasBackButton && (
          <IconButton
            Icon={CloseIcon}
            className={styles.close}
            data-test="close-popup"
            onClick={popupInstance.close}
          />
        )}
        <MyProfile
          metaBlockClassName={styles.profileMetaBlock}
          popupInstance={popupInstance}
        />
      </div>
    </Popup>
  );
};
